import React from 'react';
import UHC_Slider, { Pipes, UHC_SliderProps } from '../../../Dumb/Organisms/Slider/Slider';
import UHC_Vcpu from './Vcpu/Vcpu'
import { SliderColorsOptions } from '@/components/Dumb/Organisms/Slider/sliderColors';

export interface PipeVcpu extends Pipes {
    vcpu?: number
}
export interface UHCSliderCompleteProps extends UHC_SliderProps {
    pipes: PipeVcpu[]
    ['aria-labelledBy']: string
    color: SliderColorsOptions
}

const UHCSliderAndVcpu: React.FC<UHCSliderCompleteProps> = (props: UHCSliderCompleteProps) => {
    return ( 
        <>
            <UHC_Vcpu color={props.color} currentPipe={props.pipeState.pipeSelected} pipes={props.pipes} />
            <UHC_Slider color={props.color} aria-labelledBy={props['aria-labelledBy']} pipesDisabled={props.pipesDisabled} pipeState={{ pipeSelected: props.pipeState.pipeSelected, setPipeSelected: props.pipeState.setPipeSelected }} pipes={props.pipes} />
        </>
    );
};

export default UHCSliderAndVcpu;
